<template>
  <v-container class="px-5">
    <v-row v-if="loading">
      <v-col
        class="text-center"
        cols="12"
      >
        <v-icon
          size="10rem"
          class="primary--text"
        >
          fas fa-circle-notch fa-spin
        </v-icon>
        <h1>{{ $t('complete.wait-header') }}</h1>
      </v-col>
      <v-col md="12"
             lg="9"
             class="text-center mx-auto">
        <p>{{ $t('complete.wait-desc') }}</p>
      </v-col>
    </v-row>
    <v-row v-if="registrationError">
      <v-col class="text-center"
             cols="12">
        <v-icon size="10rem"
                class="red--text">
          far fa-frown
        </v-icon>
        <h1>{{ $t('complete.fail-header') }}</h1>
      </v-col>
      <v-col md="12"
             lg="9"
             class="text-center mx-auto">
        <p>{{ $t('complete.fail-desc') }}</p>
      </v-col>
    </v-row>
    <v-row v-if="registrationSuccess">
      <v-col class="text-center mx-auto"
             md="12"
             lg="9">
        <v-icon size="10rem"
                class="green--text">
          fas fa-user-check
        </v-icon>
        <h1>{{ $t('complete.success-header') }}</h1>
      </v-col>
      <v-col md="12"
             lg="9"
             class="text-center mx-auto">
        <p>{{ $t('complete.success-desc-1') }} <b>{{ verificationData.ContactEmail }}</b></p>
        <p>{{ $t('complete.success-desc-2') }}</p>
        <v-btn class="mt-3 primary"
               tile
               href="https://business.b2-impact.fi"
               x-large>
          {{ $t('complete.businessb2impactLink') }}
          <v-icon rigth class="ml-3">fas fa-angle-double-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { apiResource } from '../plugins/axios'

  export default {
    props: ['requestId', 'taskId'],
    data: () => ({
      loading: false,
      verified: false,
      verificationData: null
    }),
    computed: {
      registrationSuccess () {
        return this.verified === true &&
          this.verificationData !== null &&
          this.verificationData.Success === true
      },
      registrationError () {
        return (this.verificationData !== null && this.verificationData.Success === false) || (this.verificationData === null && this.verified === true)
      }
    },
    mounted () {
      if (!this.verified) {
        this.verifyRegistration()
      } else {
        console.log('already verified')
      }
    },
    methods: {
      verifyRegistration () {
        this.loading = true

        apiResource.post('registration/verify/?requestid=' + this.requestId + '&taskid=' + this.taskId, {}).then((response) => {
          this.loading = false
          this.verificationData = response.data
          this.verified = true
          if (!this.verificationData.DocumentIsSigned) {
            this.$store.commit('setMessage', { type: 'error', text: 'servererror.2', translate: true })
            this.$router.push('/digital-signing')
          }
        }).catch((errorResponse) => {
          this.loading = false
          this.verified = true
          console.log('error', errorResponse)
        })
      }
    }
  }
</script>
